import { store } from '../store/store'

const auth = (to, from, next) => {
  let token = false
  store.commit('auth/setInitialRoute', to)

  if (!store.getters['auth/authCheck']) {
    let cookies = document.cookie
    token = /token=(.*);?/.exec(cookies)
  }
  if (store.getters['auth/authCheck'] || (token && token[0])) {
    next()
  } else {
    next({name: 'login'})
  }
}

const guest = (to, from, next) => {
  if (!store.getters['auth/authCheck']) {
    next()
  } else {
    next({name: 'agenda.index'})
  }
}

const isAdmin = (to, from, next) => {
  if (store.getters['auth/isAdmin']) {
    next()
  } else {
    next({name: 'agenda.index'})
  }
}

const isManager = (to, from, next) => {
  if (store.getters['auth/isManager']) {
    next()
  } else {
    next({name: 'agenda.index'})
  }
}

const isManagerPlus = (to, from, next) => {
  if (store.getters['auth/isManager'] || store.getters['auth/isAdmin']) {
    next()
  } else {
    next({name: 'agenda.index'})
    }
}

const isSimple = (to, from, next) => {
  if (store.getters['auth/isSimple']) {
    next()
  } else {
    next({name: 'agenda.index'})
  }
}

export {
  auth,
  guest,
  isAdmin,
  isManager,
  isSimple,
  isManagerPlus
}



// WEBPACK FOOTER //
// ./src/router/middlewares.js